export const axiosConfig = (session) => {
    const config = {
        baseURL: process.env.API_URL
    }

    if (session) {
        config.headers = {
            session
        }
    }

    return config
}
